import { useEffect, useState } from "react";
import "./style.css";
import BanggoodService from "../../../../service/BanggoodService";
import OrderService from "../../../../service/OrderService";

import localeText from "../../../../locale";

const ShippingDetails = ({ order }) => {
  const banggoodService = new BanggoodService();
  const orderService = new OrderService();

  const [trackInfo, setTrackInfo] = useState(null);

  const fetchBanggoodOrder = async () => {
    let sale_record_id = order.bangood_order_id
    let orderInfo = await banggoodService.getOrderInfo(sale_record_id)
    orderInfo = orderInfo.data['sale_record_id_list'][0]['order_list'][0]
    let orderHistory = await banggoodService.getOrderHistory({
      sale_record_id: sale_record_id,
      order_id : orderInfo['order_id']
    })

    orderHistory = orderHistory.data
    let track_number = orderHistory['track_number']
    let order_status = orderHistory['order_history'][0]['status']
    return {
      'order_id' : orderInfo['order_id'],
      'sale_record_id' : sale_record_id,
      'trackingobject': track_number,
      'shipping_company': orderInfo['shipmethod_code'],
      'status': order_status
    }
  }


  const fetchTrackInfo = async () => {
    let order = await fetchBanggoodOrder()
    let res = await banggoodService.getTrackInfo(order.order_id)
    setTrackInfo(res.data.track_info);
    if(!res?.data?.track_info?.length){
      return
    }
  }

  useEffect(() => {
    if (!order?.bangood_order_id) {
      return
    }
    fetchTrackInfo()
  }, [order])

  return (
    <div className="shipping-container">
      <h4>{localeText('trackingData')}</h4>
      {
        trackInfo && trackInfo.map((event,index) => {
          return (
            <div key={index} className="shipping-event">
              <div className="shipping-event-time">{event.time}</div>
              <div>{event.event}</div>
            </div>
          )
        })
      }
    </div>
  );
};

export default ShippingDetails
